import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const createQueryData = (location) => {
  if (location?.search) {
    try {
      const search = location.search.substring(1);
      const query = JSON.parse(
        '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
        function (key, value) {
          return key === "" ? value : decodeURIComponent(value);
        }
      );
      return query;
    } catch (error) {
      return {};
    }
  }
};

export const useQueryData = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [queryData, setQueryData] = React.useState(createQueryData(location));
  const [queryString, setQueryString] = React.useState("");

  useEffect(() => {
    const query = createQueryData(location);
    setQueryData(query);
  }, [location, queryString]);

  const updateQuery = (payload) => {
    const query = `?${new URLSearchParams(payload).toString()}`;
    navigate({ search: query }, { replace: true });
    setQueryString(query);
  };

  return { queryData, queryString, updateQuery };
};
